/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  if(window.location.hash !== '') {
    var hash_item = document.querySelector(window.location.hash);
    if(hash_item && hash_item.classList.contains('accordion')) {
      var accordion_content = hash_item.querySelector('.accordion-content'),
          accordion_button;

      if(!hash_item.classList.contains('advanced')) {
        accordion_button = hash_item.querySelector('.accordion-title');
      } else {
        accordion_button = hash_item.querySelector('.accordion-toggle');
      }

      hash_item.classList.add('open');
      accordion_button.setAttribute('aria-expanded', 'true');
      accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
    }
  }

  var accordions = document.querySelectorAll('.accordion, .table-accordion');
  if(accordions) {
    accordions.forEach((accordion) => {
      var accordion_button = accordion.querySelector('.accordion-title'),
          accordion_content = accordion.querySelector('.accordion-content');

      if(accordion.classList.contains('table-accordion')) {
        accordion_button = accordion.querySelector('.table-accordion-title');
        accordion_content = accordion.querySelector('.table-accordion-content');
      }

      accordion_button.addEventListener('click', (e) => {
        e.preventDefault();

        var is_open = accordion.classList.contains('open');

        const toggleAccordion = () => {
          if(!is_open) {
            accordion.classList.add('open');
            accordion_button.setAttribute('aria-expanded', 'true');
            accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
          } else {
            accordion.classList.remove('open');
            accordion_button.setAttribute('aria-expanded', 'false');
            accordion_content.style.maxHeight = null;
          }
        };

        toggleAccordion();
      });
    });
  }
}());